// @flow

import React from 'react'
import styled from 'styled-components'
import { StyledFormInfo } from 'src/components/Form'
import { RoomSummary } from 'src/components/RoomSummary'
import { BookingSummary } from 'src/components/BookingSummary'
import PaymentSummary from 'src/components/PaymentSummary'
import type { Booking as BookingType } from 'src/types'

type Props = {
  booking: BookingType,
  bookingDeposit: string,
  adminFee: string,
  paymentPlan: string,
  modalLayout?: boolean
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

type State = { isOpen: any, lastWidth: any }

export class BookingInfo extends React.PureComponent<Props, State> {
  state = { isOpen: true, lastWidth: window.innerWidth }

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  onOpenIt = (e: any) => {
    if (!this.state.isOpen && this.state.lastWidth !== e.target.innerWidth) {
      this.setState({ isOpen: true })
    }
  }

  getSvg = (rotate: boolean) => {
    return (
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        className="css-19bqh2r"
        style={{ transform: !rotate ? 'rotate(0deg)' : 'rotate(180deg)' }}
        focusable="false"
        role="presentation"
      >
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
      </svg>
    )
  }

  componentDidMount() {
    window.addEventListener('resize', this.onOpenIt)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onOpenIt)
  }

  render() {
    const { booking, bookingDeposit, adminFee, paymentPlan, modalLayout } = this.props
    const {
      moveIn,
      membership,
      location,
      room: { name, type, locationRef }
    } = booking
    const { isOpen } = this.state
    const finalName = locationRef === 'tccw' ? type : name
    return (
      <StyledFormInfo isSticky={true} modalLayout={modalLayout}>
        {!modalLayout && (
          <Container>
            <RoomSummary name={finalName} size={location.name} />
          </Container>
        )}

        {isOpen && (
          <BookingSummary
            moveIn={moveIn}
            booking={booking}
            membership={membership}
            modalLayout={modalLayout}
          />
        )}
        {isOpen && (
          <PaymentSummary
            bookingDeposit={bookingDeposit}
            adminFee={adminFee}
            membership={membership}
            noMargin={true}
            paymentPlan={paymentPlan}
            modalLayout={modalLayout}
          />
        )}
      </StyledFormInfo>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BookingInfo/index.js